import { NextPage } from "next"
import Error from "next/error"
import Head from "next/head"
import { useRouter } from "next/router"
import { useState, useMemo } from "react"

import Sp from "~/components/atoms/Sp"
import Breadcrumb from "~/components/organisms/Breadcrumb"
import Footer from "~/components/organisms/Footer"
import Header from "~/components/organisms/Header"
import { SearchPage } from "~/components/pages/SearchPage"
import ObservedTabBar from "~/observers/TabBar"
import { staticPath, internalLink } from "~/services/helper"
import { InfraNextPageContext } from "~/types/InfraNextPageContext"
import { ReturnGetInitialProps } from "~/types/ReturnGetInitialProps"

const getInitialProps = async ({ initialStoreData: { masterDataStore }, query, res }: InfraNextPageContext) => {
  const baseTitle = query.pickup === "1" ? "注目のシゴト一覧" : "シゴト一覧"
  const { gradYears, majorOccupations, minorOccupations, regions } = await masterDataStore.fetch()
  // NOTE: 新卒求人ページ廃止のため、暫定対応として 404 を返す
  res.statusCode = 404

  return { gradYears, majorOccupations, minorOccupations, regions, baseTitle }
}

type GetInitialProps = ReturnGetInitialProps<typeof getInitialProps>

const Page: NextPage<GetInitialProps> = (props) => {
  // NOTE: 新卒求人ページ廃止のため、暫定対応として 404 を返す
  return <Error statusCode={404} />

  // const { gradYears, majorOccupations, minorOccupations, regions, baseTitle } = props
  // const router = useRouter()
  // const [maybeTitle, setMaybeTitle] = useState<string>()
  // const [maybePageCount, setMaybePageCount] = useState<string>()
  // const title = useMemo(() => {
  //   if (!maybeTitle) {
  //     return baseTitle
  //   }

  //   let text = `${maybeTitle}`
  //   if (maybePageCount != null) {
  //     text += `（${maybePageCount}ページ目）`
  //   }
  //   return text
  // }, [maybeTitle, maybePageCount, baseTitle])

  // const crumbs = [
  //   { name: "新卒求人トップ", link: internalLink(`/new-grad-jobs`) },
  //   { name: title, link: router.asPath },
  // ]

  // return (
  //   <>
  //     <Head>
  //       {/* NOTE: ssr時は`新卒求人一覧 | Infra新卒（インフラ新卒）`と表示(具体的な検索結果が表示されない) */}
  //       <title>{title} | Infra新卒（インフラ新卒）</title>
  //       <meta
  //         name="description"
  //         content="職種別の新卒求人情報を掲載！あなたの指向性から適切な企業を探したり、エントリーシートやグループディスカッションの対策、面接対策などをサポートする就職相談会を実施中！"
  //       />
  //       <meta property="og:title" content={`${title} | Infra新卒（インフラ新卒）`} />
  //       <meta
  //         property="og:description"
  //         content="職種別の新卒求人情報を掲載！あなたの指向性から適切な企業を探したり、エントリーシートやグループディスカッションの対策、面接対策などをサポートする就職相談会を実施中！"
  //       />
  //       <meta property="og:image" content={`${process.env.APP_HOST + staticPath("/static/images/ogp.png")}`} />
  //     </Head>

  //     <Header logoType="NewGradJobs" showTab />
  //     <SearchPage
  //       gradYears={gradYears}
  //       majorOccupations={majorOccupations}
  //       minorOccupations={minorOccupations}
  //       regions={regions}
  //       onTitleChange={setMaybeTitle}
  //       onPageCountChange={setMaybePageCount}
  //     />

  //     <Breadcrumb crumbs={crumbs} />
  //     <Sp>
  //       <ObservedTabBar selectedTabIndex={0} />
  //     </Sp>
  //     <Footer />
  //   </>
  // )
}

Page.getInitialProps = getInitialProps

export default Page
